<template>
  <div class="my-video" :style="{ top: `${-1 * translateY}px` }" v-if="videoVisible">
    <div id="hidebg"></div>
    <div id="hidebox">
      <el-dialog :visible.sync="videoVisible" class="dialog" width="70%" :show-close="false" :destroy-on-close="true"
        style="background-color: rgba(0, 0, 0, 0.9)" @close="close">
        <video :id="videoId" width="100%" v-if="videoVisible" class="swiper-video"
          :class="{ 'swiper-video-safari': isSafari }" :muted="false" controls loop autoplay :src="videoSrc"></video>
        <div class="video-close" :class="{ 'video-close2': isSafari }">
          <img style="width:25px;height:25px;" src="https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/video/close-icon.png" class="icon icon-close" @click="close" :code-stm="`event, PAGEURL, ${maidiansuffix} 关闭弹框视频`"/>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey, isSafariFun, videoPlayInAndroidWX } from "@/utils/utils.js";

export default {
  props: {
    videoSrc: {
      type: String,
      default: ""
    },
    isShow: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: String,
      default: ""
    },
    translateY: {
      type: Number,
      default: 0
    },
    maidiansuffix: {
      type: String,
      default: ""
    }
  },
  watch: {
    isShow: {
      handler(n) {
        this.videoVisible = n
        if (n) {
          this.showVideo()
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      isPortrait: isPortraitFun(),
      isSafari: isSafariFun(),
      videoVisible: false
    };
  },
  components: {},
  mounted: function () {

  },
  methods: {
    //显示弹出层
    showVideo() {
      this.videoVisible = true;
      // let hideobj = document.getElementById("hidebg");
      // hideobj.style.display = "block"; //显示隐藏层
      // hideobj.style.height = document.body.clientHeight + "px"; //设置隐藏层的高度为当前页面高度
      // console.log(document.getElementById("hidebox"))
      // document.getElementById("hidebox").style.display = "block"; //显示弹出层
      // videoPlayInAndroidWX(this.videoId, this)
    },
    //关闭弹出层
    close() {
      console.log("关闭弹窗");
      this.$emit("closeDialog")
      this.videoVisible = false;
      if(this.maidiansuffix !== 'ev5 E-GMP视频'){//ev5
        document.documentElement.style.overflow = 'scroll';
      }
      document.body.scroll = "yes";
      // let hideobj = document.getElementById("hidebg");
      // hideobj.style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
.my-video {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
}

#hidebg {
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: #000;
  width: 100%;
  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  filter: alpha(opacity=60);
  /*设置透明度为60%*/
  opacity: 0.6;
  /*非IE浏览器下设置透明度为60%*/
  display: none;
  z-index: 2;
}

.video-close {
  margin-top: 10px;
  text-align: center;
}

.video-close2 {
  margin-top: 0;
}

.swiper-video-safari {
  margin-top: -40px;
}
.swiper-video-safari{
	outline:none;
	-webkit-tap-highlight-color:rgba(0,0,0,0);
}
.swiper-video-safari:focus{
	outline:none;
	-webkit-tap-highlight-color:rgba(0,0,0,0);
}

.icon-close {
  font-size: 30px;
}

::v-deep .el-dialog__wrapper {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .el-dialog {
    width: 74% !important;
    margin: 0 auto !important;
    background: #000;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
